import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/lock.svg';
const _hoisted_1 = {
    key: 0,
    class: "personal-info-page"
};
const _hoisted_2 = { class: "pi-section" };
const _hoisted_3 = { class: "pi-section" };
const _hoisted_4 = { class: "pi-locked-card" };
const _hoisted_5 = { class: "pi-locked-row" };
const _hoisted_6 = { class: "pi-value" };
const _hoisted_7 = { class: "pi-locked-card" };
const _hoisted_8 = { class: "pi-locked-row" };
const _hoisted_9 = { class: "pi-value" };
const _hoisted_10 = { class: "contact-drawer-content" };
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PersonalInformationPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, updateCustomerDetails } = useCustomer();
        const sections = ref([]);
        const originalValues = ref({});
        const contactDrawer = ref(null);
        const hasChanges = computed(() => {
            if (!sections.value.length || !sections.value[0]?.fields)
                return false;
            return sections.value[0].fields.some((f) => f.value !== originalValues.value[f.label]);
        });
        function findFieldValue(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function onLoad() {
            getCustomer(() => {
                sections.value = [{
                        fields: [
                            { label: 'First name', type: 'text', value: state.customer.person.firstName || '', required: true, validationText: 'Please enter your first name' },
                            { label: 'Last name', type: 'text', value: state.customer.person.lastName || '', required: true, validationText: 'Please enter your last name' },
                        ]
                    }];
                originalValues.value = {
                    'First name': state.customer.person.firstName || '',
                    'Last name': state.customer.person.lastName || '',
                };
            });
        }
        function openMailto() {
            window.location.href = 'mailto:help@moneyguided.com';
        }
        function updateDetails() {
            const updateRequest = {
                firstName: findFieldValue('First name'),
                lastName: findFieldValue('Last name'),
            };
            updateCustomerDetails(updateRequest, () => {
                getCustomer(null, false);
                router.push('/settings');
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Personal Information" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pi-section-title" }, "About me", -1)),
                                    _createVNode(InputSections, {
                                        ref: "inputSections",
                                        sections: sections.value,
                                        theme: "light"
                                    }, null, 8, ["sections"])
                                ]),
                                _createElementVNode("div", _hoisted_3, [
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pi-section-title" }, "Contact details", -1)),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "pi-label" }, "Email", -1)),
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(state).customer.person.email), 1)
                                        ]),
                                        _cache[3] || (_cache[3] = _createElementVNode("img", {
                                            src: _imports_0,
                                            alt: "",
                                            class: "pi-lock-icon"
                                        }, null, -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "pi-label" }, "Mobile no.", -1)),
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(state).customer.person.mobilePhone), 1)
                                        ]),
                                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                                            src: _imports_0,
                                            alt: "",
                                            class: "pi-lock-icon"
                                        }, null, -1))
                                    ]),
                                    _createElementVNode("div", {
                                        class: "pi-help-text",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (contactDrawer.value?.openDrawer()))
                                    }, "Something not right? Request to update")
                                ]),
                                _createVNode(MGButton, {
                                    text: "Update",
                                    disabled: !hasChanges.value,
                                    onClick: updateDetails,
                                    fullWidth: true
                                }, null, 8, ["disabled"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(DrawerPanel, {
                    ref_key: "contactDrawer",
                    ref: contactDrawer,
                    close: true,
                    divider: false,
                    openHeight: '50%',
                    blurBackground: true,
                    bottom: "-95px",
                    closedHeight: "0px",
                    backgroundColor: "transparent",
                    openBackgroundColor: "#fff"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "contact-drawer-title" }, "Something not right?", -1)),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "contact-drawer-description" }, "If you need to update your mobile phone number, let us know and we will sort it for you.", -1)),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "contact-drawer-email" }, "help@moneyguided.com", -1)),
                            _createVNode(MGButton, {
                                text: "Get in touch",
                                arrow: true,
                                onClick: openMailto
                            })
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
